import { styled } from "@acko-tech/building-blocks.ui.common";

export const ModalContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 24px 20px 12px;
  background: linear-gradient(
    180deg,
    #f3edff 0%,
    #ffffff 32%,
    #ffffff 100%
  );
  border-radius: 24px 24px 0 0;
  color: #34324c;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;

  @media (min-width: 768px) {
    padding: 20px 32px 0;
    border-radius: 20px;
    background: linear-gradient(
      170.17deg,
      #e8dfff 9.4%,
      #ffffff 33.04%,
      #fff8fd 52.93%,
      #ffffff 67.77%,
      #ffffff 85.58%
    );
  }
`;

export const IllustrationWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;

  > div {
    display: block;
    width: 140px !important;
    height: 140px !important;
  }

  svg {
    display: block;
    width: 140px !important;
    height: 140px !important;
  }
`;

export const Heading = styled.h2`
  max-width: 280px;
  margin: 0 auto 16px;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  text-align: center;
  letter-spacing: -0.1px;

  span {
    display: inline;
    background: linear-gradient(
      90deg,
      #271c7c 2.37%,
      #ac28ff 41.49%,
      #452f70 80.6%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }
`;

export const Subtext = styled.p`
  align-self: stretch;
  margin: 0 auto 16px;
  color: var(--Neutral-N500, #36354c);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  opacity: 0.8;
  white-space: pre-line;
`;

export const OfferPanel = styled.div`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  margin-top: 6px;
  padding: 16px 12px;
  overflow: visible;
  border-radius: 16px;
  border: 0.6px solid #ffdbf5;
  background: linear-gradient(
    103deg,
    #fff 3.11%,
    #fff 51.55%,
    #fff2fe 100%
  );

`;

export const PriceSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 36px;
  gap: 12px;
`;

export const PriceLabel = styled.span`
  color: #34324c;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const PriceValues = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  color: #34324c;
  white-space: nowrap;

  strong {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
  }

  s {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }
`;

export const Sparkle = styled.img`
  position: absolute;
  pointer-events: none;
  display: block;
  z-index: 2;

  /* Figma 19153:34621 / 19153:34630 — (22.86, 0) in group; panel y=6 → top -6 */
  &[data-position="top-left"] {
    width: 14.86px;
    height: 13px;
    top: -6px;
    left: 22.86px;
  }

  /* Figma 19153:35634 — (406.4, 142.4) in 440×154 panel */
  &[data-position="bottom-right"] {
    width: 21px;
    height: 21px;
    right: 10px;
    bottom: -10px;

    @media (min-width: 768px) {
      right: 12px;
    }
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  border-radius: 0;

  width: 100%;
`;

/* Pill only — never a full-width second card */
export const SectionLabel = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  margin: 0;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #efe9fb 0%, #fffce7 50%, #fbe9ea 100%);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0;

  span {
    color: #8617d0;
    background: linear-gradient(90deg, #451999 0%, #d300c9 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const ItemList = styled.ul`
  margin: 0;
  padding-left: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
  list-style: none;
`;

/* Figma 19153:35949 / Label/Small — addon name + sum assured / IDV copy */
export const Item = styled.li`
  align-self: stretch;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  opacity: 0.8;

  s {
    text-decoration: line-through;
  }

  b {
    font-weight: 700;
  }

  & + & {
    margin-top: 0;
  }
`;
